import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { pondsApi } from '@/features/ponds/api/pondsApi';

/**
 * Returns a pondId -> pond name map for a farm.
 * Shares the ['ponds', farmId] query with useFeaturePageState so it is served from cache.
 */
export function usePondNames(farmId: string | undefined): Record<string, string> {
  const { data: ponds = [] } = useQuery({
    queryKey: ['ponds', farmId],
    queryFn: () => pondsApi.list(farmId!),
    enabled: !!farmId,
    staleTime: 5 * 60 * 1000,
  });

  return useMemo(
    () => Object.fromEntries(ponds.map((pond) => [pond.id, pond.name])),
    [ponds]
  );
}
